import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { serializeError } from 'serialize-error';
import { TrackingContextProvider } from './helper-services/TrackingContextProvider';

@injectable()
export class LogService {
  private axiosInstance: AxiosInstance;

  private trackingContextProvider: TrackingContextProvider;

  sessionId: string;

  constructor(axiosInstance: AxiosInstance, trackingContextProvider: TrackingContextProvider) {
    this.axiosInstance = axiosInstance;
    this.sessionId = '';
    this.trackingContextProvider = trackingContextProvider;
  }

  private getContext() {
    return {
      sessionId: this.sessionId,
      browserTrackId: this.trackingContextProvider.browserTrackId,
      instanceTrackId: this.trackingContextProvider.instanceTrackId,
      eventTime: new Date(),
    };
  }

  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }

  clearSession() {
    this.sessionId = '';
  }

  async logError(error: any, context = {}) {
    try {
      await this.axiosInstance.post('api/log/error/', {
        message: JSON.stringify(serializeError(error)),
        context: { ...this.getContext(), ...context },
      });
    } catch (error) {
      console.log(error);
    }
  }

  async logInfo(message: string, context = {}) {
    try {
      await this.axiosInstance.post('api/log/info/', { message, context: { ...this.getContext(), ...context } });
    } catch (error) {
      console.log(error);
    }
  }
}
